import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-application-dialog',
  templateUrl: './application-dialog.component.html',
  standalone: false,
})
export class ApplicationDialogComponent {
  leadId: string = '';
  selectedProcessorType: string | undefined;
  selectedProcessor: string | undefined;

  constructor(
    public dialogRef: MatDialogRef<ApplicationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      leadId: string;
      type: string;
    },
  ) {
    this.leadId = data.leadId;
    this.selectedProcessorType = data.type;
  }

  ngOnInit() {}

  ngAfterViewInit() {}

  btnSubmit_click() {
    this.dialogRef.close(true);
  }

  btnClose_click() {
    this.dialogRef.close(false);
  }
}
